import { SearchOutlined, TuneOutlined } from "@mui/icons-material";
import { Box, Chip, Collapse, IconButton, InputBase } from "@mui/material";
import { isEmpty } from "lodash";
import { useContext } from "react";
import { FilterContext } from "../../components/Filter";
import { PeriodField } from "../../components/Period";
import { useUserInfo } from "../../utils/security";

export const FinancialSimpleFilter = () => {
    const { userInfo } = useUserInfo();
    const { compact, filterVisible, setFilterVisible, setFilter, filter } =
        useContext(FilterContext);

    const quickFilter = [];

    if (!isEmpty(filter.transactionTypes)) {
        const transactionTypesMap = userInfo.transactionTypes.reduce((acc, item) => {
            acc[item.id] = item.name;
            return acc;
        }, {});

        quickFilter.push({
            key: "transactionTypes",
            label:
                "Typy transakcí: " +
                filter.transactionTypes.map((tid) => transactionTypesMap[tid]).join(", "),
            onDelete: () => setFilter({ ...filter, transactionTypes: undefined }),
        });
    }

    console.log("Filter", filter);
    return (
        <Box
            sx={{
                mt: 1,
                mb: 3,
                flex: "0 0 auto",
                px: compact ? 2 : 0,
            }}>
            <Box
                sx={(theme) => ({
                    display: "flex",
                    flexDirection: "column",
                    gap: theme.spacing(2),
                })}>
                <PeriodField
                    value={filter.period}
                    onChange={(period) => setFilter({ ...filter, period })}
                />
                <Box
                    sx={(theme) => ({
                        display: "flex",
                        flexDirection: "row",
                        gap: theme.spacing(2),
                        alignItems: "center",
                        borderRadius: theme.spacing(3),
                        paddingTop: theme.spacing(0.5),
                        paddingRight: theme.spacing(1),
                        paddingBottom: theme.spacing(0.5),
                        paddingLeft: theme.spacing(1),
                        backgroundColor:
                            theme.palette.surfaceDim?.main || theme.palette.grey["400"],
                    })}>
                    <SearchOutlined />
                    <InputBase
                        value={filter.fulltext || ""}
                        onChange={(e) => setFilter({ ...filter, fulltext: e.target.value })}
                        placeholder="Filtrovat..."
                        sx={{ flex: 1 }}
                    />
                    <IconButton onClick={() => setFilterVisible(!filterVisible)} sx={{ flex: 0 }}>
                        <TuneOutlined />
                    </IconButton>
                </Box>
            </Box>
            {!isEmpty(quickFilter) && (
                <Collapse in={!filterVisible}>
                    <Box sx={{ my: 1 }}>
                        {quickFilter.map((item) => (
                            <Chip
                                key={item.key}
                                label={item.label}
                                color="primary"
                                onDelete={item.onDelete}
                            />
                        ))}
                    </Box>
                </Collapse>
            )}
        </Box>
    );
};
